import { STUDIO_COMP_REF_TYPE } from '../consts';
import { isStaticPage } from '../rule-mappers/shared/helpers';
import { getEditorCapabilitiesForHost } from './editor-host-to-editor-type';
export const getAxeBreakpointId = (a11yWizardAdapter, editorHost, metadata, compId) => {
  const {
    supportsNonClassicDomOrderFix,
    usesClassicCompRefWithBreakpoint
  } = getEditorCapabilitiesForHost(editorHost);
  const compRefType = usesClassicCompRefWithBreakpoint ? undefined : STUDIO_COMP_REF_TYPE;
  const canvasSize = metadata == null ? void 0 : metadata.canvasSize;
  const fallbackBreakpointId = (metadata == null ? void 0 : metadata.breakpointId) ?? STUDIO_COMP_REF_TYPE;
  if (supportsNonClassicDomOrderFix && isStaticPage(metadata == null ? void 0 : metadata.itemType) && typeof canvasSize === 'number' && Number.isFinite(canvasSize)) {
    return a11yWizardAdapter.getBreakpointIdByWidth({
      id: compId,
      type: compRefType ?? STUDIO_COMP_REF_TYPE
    }, canvasSize);
  }
  return fallbackBreakpointId;
};
//# sourceMappingURL=get-axe-breakpoint-id.js.map